import { Fragment } from 'react';

import { stripMarkup } from '@labradorsports/utils';

interface Props {
    value: string;
}

const SSRQuillWrapper: FC<Props> = ({ value }) => {
    const processedValue = stripMarkup(value);

    return (
        <div>
            {processedValue.split('\n').map((line, idx) => (
                <Fragment key={`${line}_${idx}`}>
                    {line}
                    <br />
                </Fragment>
            ))}
        </div>
    );
};

export default SSRQuillWrapper;
